import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=4756694c&scoped=true&"
import script from "./sys.vue?vue&type=script&lang=js&"
export * from "./sys.vue?vue&type=script&lang=js&"
import style0 from "./sys.vue?vue&type=style&index=0&id=4756694c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4756694c",
  null
  
)

export default component.exports